<template>
    <div class="bg-white py-6">
      <div class="container mx-auto text-center">
        <h1 class="text-4xl font-bold text-gray-900">Properti Dijual</h1>
        <p class="text-gray-500 mt-2">Segera beli Properti Sekarang dan Dapatkan Penawaran Terbaik di Teamss.biz</p>
        <div class="flex justify-center mt-4">
          <button
            v-for="(filter, index) in filters"
            :key="index"
            @click="selectFilter(filter)"
            :class="{
              'bg-primary text-white': selectedFilter === filter,
              'bg-white text-gray-700': selectedFilter !== filter,
              'border-gray-300': true,
              'px-4 py-2 rounded-full border mx-2': true,
            }"
          >
            {{ filter }}
          </button>
        </div>
      </div>
    </div>
  </template>


  <script lang="ts">
  import { defineComponent } from 'vue';


  export default defineComponent({
    name: 'Filter',
    data() {
      return {
        filters: [
          'Semua Harga',
          '350 Juta - 500 Juta',
          '500 Juta - 750 Juta',
          '750 Juta - 1 Milyar',
          'Lebih dari 1 Milyar',
        ],
        selectedFilter: 'Semua Harga',
      };
    },
    methods: {
      selectFilter(filter: string) {
        this.selectedFilter = filter;
      },
    },
  });
  </script>

  <style scoped>
  /* Add any additional styles here */
  </style>
